import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from "../../../../../../auth/auth.service";
import {UserSubscriptionIds} from "../../../../../../user/user-subscription";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../store";

@Component({
    selector: 'db-plan-not-supported',
    templateUrl: './plan-not-supported.component.html',
    styleUrls: ['./plan-not-supported.component.scss'],
    standalone: false
})
export class PlanNotSupportedComponent implements OnInit {

  @Output() readonly onResize: EventEmitter<[number, number]> = new EventEmitter<[number, number]>();
  @Output() readonly onClose: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _authService: AuthService,
  ) { }

  ngOnInit() {
    this._resize();
  }

  public openChat(): void {
    window['Smooch']?.open();
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
/*    const chatStatus = TypeUtils.isDefined(window['zE']) && window['zE']('messenger:get', 'chat:department', 'Support') && window['zE']('messenger:get', 'chat:department', 'Support').status;
    if (TypeUtils.isDefined(chatStatus) && chatStatus === 'online') {
      /!*window['zE']('messenger', 'chat:removeTags', ['generic_support']);
      window['zE']('messenger', 'chat:addTags', ['open_livechat']);*!/

      /!*window['zE']('messenger', 'chat:send', 'Open LiveChat');*!/
    }*/
  }

  public close(): void {
    this.onClose.emit();
  }

  private _resize(): void {
    this.onResize.emit([255, 500]);
  }

  public logout(): void {
    this._authService.logoutFromProfile(`/sign-up?subscr_id=${UserSubscriptionIds.TRIAL_BOOSTER}`);
    this.onClose.emit();
  }
}
